<template>
  <el-row justify="center" align="middle">
    <el-col :xs="24" :sm="20" :md="16" :lg="10" :xl="6">
      <el-row
        justify="center"
        align="middle"
        style="flex-direction: column; max-width: 620px"
      >
        <div style="width: 100%">
          <rose-grid :dollar="1" :data="card.incoming"></rose-grid>
        </div>
        <div id="charts"></div>

        <hr style="hr" />
        <div class="head-box">
          <div class="flex-center">
            <div class="g lt">
              <rose-grid :data="card.weekly" />
            </div>
            <div class="g rt">
              <rose-grid :data="card.ytd" />
            </div>
          </div>
          <div class="flex-center">
            <div class="g lb">
              <rose-grid :data="card.assets" />
            </div>
            <div class="g rb">
              <rose-grid :data="card.total" />
            </div>
          </div>
        </div>
        <hr style="hr" />

        <el-table :data="invest" size="small" :stripe="true">
          <el-table-column fixed prop="net_day" label="日期" width="100" />
          <el-table-column
            prop="com"
            label="变动"
            width="100"
            :formatter="rate"
          />

          <el-table-column prop="net_value" label="净值" width="100" />
          <el-table-column label="YTD" width="100">
            <template #default="scope">
              {{ get_ytd(scope.row.net_value, scope.row.net_day) }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
            label="资产"
            width="120"
            :formatter="toFix4"
          />
          <el-table-column prop="share" label="份额" width="100" />
        </el-table>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
// import Chart from "../components/Chart.vue";
// import RoseGrid from "../components/RoseGrid.vue";
// import { getCurrentInstance, onMounted } from "vue";
import * as echarts from "echarts";
import RoseGrid from "../components/RoseGrid.vue";

export default {
  name: "report",
  components: {
    RoseGrid,
  },
  data() {
    return {
      isWechat: false,
      invest: [],
      net_value: [],
      net_day: [],
      go: 0,
      activeName: "value_table",
      chart: "",
      year_value: 0,
      year_value_all: {
        "2019-12-31": 0,
        "2020-12-31": 0,
        "2021-12-31": 0,
        "2022-12-31": 0,
        "2023-12-31": 0,
        "2024-12-31": 0,
      },
      card: {
        assets: {},
        incoming: {},
        weekly: {},
        total: {},
        origin: {},
        ytd: {},
      },
    };
  },
  methods: {
    get_ytd(net_value, net_day) {
      let yv = 0;
      let y = net_day.substring(0, 4) - 1;
      yv = this.year_value_all[y + "-12-31"];

      if (yv) {
        return (((net_value - yv) / yv) * 100).toFixed(4);
      } else {
        return "-";
      }
    },
    handleTab(tab) {
      console.log("tab,%o", tab.paneName);
      this.activeName = tab.paneName;
      //   setTimeout(() => {
      // this.chart.resize();
      // this.draw();
      //   }, 100);
    },
    gologin() {
      this.$router.push("/login");
    },
    rate(r, w, v) {
      let d = (v * 100).toFixed(4);
      return d + "%";
    },
    toFix4(r, w, v) {
      return v.toFixed(4);
    },
    draw() {
      let myChart = echarts.init(document.getElementById("charts"));

      window.onresize = function () {
        myChart.resize();
      };
      myChart.setOption({
        title: { text: "净值趋势" },
        tooltip: {},
        xAxis: {
          data: this.net_day,
        },
        yAxis: {
          min: 1.2,
        },
        series: [
          {
            name: "净值",
            type: "line",
            smooth: true,
            data: this.net_value,
          },
        ],
      });
    },
  },

  created() {
    console.log("created");
    this.qt = this.$route.query.qt;
    if (this.qt) {
      localStorage.setItem("qt", this.qt);
    }
    let token = localStorage.getItem("report_token");
    let _self = this;
    fetch("https://www.rosegun.com/wechat/invest", {
      headers: { Authorization: token },
    })
      .then((res) => {
        console.log(res.status);
        if (res.status == 401) {
          this.$router.push("/login");
          throw new Error("Unauthorized");
        }
        return res.text();
      })
      .then((json) => {
        let it = JSON.parse(json);
        let invest = it.it;
        let origin = it.origin;
        _self.invest = invest;
        let day = [];
        let data = [];
        let year_end = invest[0].net_day.substring(0, 4) - 1 + "-12-31";
        for (let i = 0; i < invest.length; i++) {
          day.unshift(invest[i].net_day);
          data.unshift(invest[i].net_value);
          if (invest[i].net_day == year_end) {
            _self.year_value = invest[i].net_value;
          }
          if (invest[i].net_day in _self.year_value_all) {
            _self.year_value_all[invest[i].net_day] = invest[i].net_value;
          }
        }
        _self.net_day = day;
        _self.net_value = data;
        console.log("go,%s", _self.go);

        let card = {};
        card.assets = {
          title: invest[0].value.toFixed(2),
          content: "资产",
        };
        card.origin = {
          title: origin.toFixed(2),
          content: "投入",
        };
        card.incoming = {
          title: (invest[0].value - origin).toFixed(2),
          content: "总收益",
        };
        card.ytd = {
          title:
            (_self.year_value == 0
              ? "-"
              : (
                  ((invest[0].net_value - _self.year_value) /
                    _self.year_value) *
                  100
                ).toFixed(4)) + "%",
          content: "YTD",
        };
        card.total = {
          title: (((invest[0].value - origin) / origin) * 100).toFixed(4) + "%",
          content: "总涨幅",
        };
        card.weekly = {
          title: (invest[0].com * 100).toFixed(4) + "%",
          content: "周涨幅",
        };
        this.card = card;
        this.draw();
      })
      .catch((e) => {
        console.error(e);
      });
  },
};
</script>

<style>
.container {
  display: flex;
  justify-content: center;
  align-items: middle;
  flex-direction: column;
  /* max-width: 100%; */
  /* width: 980px; */
}
hr {
  width: 100%;
  border: none;
  border-top: 1px dashed #999;
  margin-top: 20px;
  margin-bottom: 20px;
}
.head-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: middle;
  flex-direction: column;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: middle;
  flex-direction: row;
  width: 100%;
  /* flex-shrink: 0; */
}
.g {
  width: 50%;
  padding: 2px;
}

.lt {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.rt {
  border-bottom: 1px solid #ccc;
}
.lb {
  border-right: 1px solid #ccc;
}
/* .el-table {
  width: 570px;
} */

#charts {
  /* width: 570px; */
  width: 100%;
  height: 300px;
}
.el-table th.el-table__cell {
  color: #ffffff;
  background-color: #d90514;
}
.dollar {
  color: #d90514;
}
.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #ffcfcf;
}
</style>
